import { render, staticRenderFns } from "./DiagnosticIssues.vue?vue&type=template&id=23882942&scoped=true"
import script from "./DiagnosticIssues.vue?vue&type=script&lang=js"
export * from "./DiagnosticIssues.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticIssues.vue?vue&type=style&index=0&id=23882942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23882942",
  null
  
)

export default component.exports